import Highway from "@dogstudio/highway";

import ProjectInfo from "../components/ProjectInfo";
import Project from "../components/Project";

const button = document.querySelector("#leistungen-button");
let projectInfos = [];

class Leistungen extends Highway.Renderer {
  onEnter() {
    button.classList.add("is-active");

    document.querySelectorAll(".project-info").forEach((el) => {
      projectInfos.push(ProjectInfo(el));
    });
  }

  onLeave() {
    // Reset styles
    button.classList.remove("is-active");

    // Destroy components
    projectInfos.forEach((el) => el.destroy());
  }
}

export default Leistungen;
